/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpParams, HttpClient, HttpHeaders } from "@angular/common/http";
import { API_PATH } from "./../../../../environments/config";
import { ProductData, StoryInfo } from "../models/product-home-interface";
import { ProductId } from "../models/product-home-interface";
import { Observable, BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { ProductHomeService } from "../product-home/product-home.service";
const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};
@Injectable({
  providedIn: "root",
})
export class ProductService {
  constructor(private http: HttpClient, private service: ProductHomeService) {}
  // throwStoryData: BehaviorSubject<any> = new BehaviorSubject({});

  fetchProduct(
    requestDataObject: ProductId,
    flag?: string
  ): Observable<ProductData> {
    let params = new HttpParams();

    params = requestDataObject.sequence
      ? params.set("sequence", requestDataObject.sequence)
      : params;
    params = params.set("isRelatedProducts", flag);
    params = requestDataObject.inventoryGroupId
      ? params.set("inventoryGroupId", requestDataObject.inventoryGroupId)
      : params;
    return this.http.get<ProductData>(`${API_PATH.apis.product}`, {
      params: params,
    });
  }

  fetchStory(request: string): Observable<any> {
    let params = new HttpParams();
    this.service.throwProductStoryId.subscribe((data) => {
      params = data.itemMasterGroupId
        ? params.set("itemMasterGroupId", data.itemMasterGroupId)
        : params;
      params = data.businessUnitId
        ? params.set("businessUnitId", data.businessUnitId)
        : params;
      params = data.inventoryGroupId
        ? params.set("inventoryGroupId", data.inventoryGroupId)
        : params;
      params = request ? params.set("storyId", request) : params;
    });

    return this.http.get<any>(`${API_PATH.apis.stories}/${request}`, {
      params: params,
    });
  }

  postFavourite(request: object) {
    return this.http.post(`${API_PATH.apis.favourite}`, request);
  }
  getFavourite() {
    return this.http.get(`${API_PATH.apis.favourite}`);
  }
  checkFavourite(request) {
    let params = new HttpParams();
    params = request ? params.set("inventoryGroupId", request) : params;
    return this.http.get<any>(`${API_PATH.apis.favourite}`, { params: params });
  }
}
